import { toast } from "react-toastify";
import axiosInstance from "../../../../../axiosInstance";
import { HRMS_FINANCE_API_URL } from "../../../../Constants/baseConstant";
import { getDomain, getUserData, getUserId } from "../../../Base/helper/baseFunctions";
import NProgress from "nprogress";

export const GetEarningHelper = async (params) => {
    var data = getUserData();
    return await axiosInstance(`/finance/getEarning`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data.domain,
        }
    })
        .then(res => {
            return { message: "Successfully", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const GetDeductionHelper = async (params) => {
    var data = getUserData();
    return await axiosInstance(`/finance/getDeduction`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data.domain,
        }
    })
        .then(res => {
            return { message: "Successfully", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const GetCustomEarningHelper = async (params) => {
    NProgress.start();
    return await axiosInstance(`/finance/getCustomEarningComponent`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: getDomain()
        },
    })
        .then((res) => {
            NProgress.done();
            return { message: "Successfully", hasError: false, data: res?.data };
        })
        .catch((err) => {
            NProgress.done();
            return { message: "Error", hasError: true, data: err?.response?.data };
        });
};

export const GetCustomDeductionHelper = async (params) => {
    NProgress.start();
    return await axiosInstance(`/finance/getCustomDeductionComponent`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: getDomain()
        },
    })
        .then((res) => {
            NProgress.done();
            return { message: "Successfully", hasError: false, data: res?.data };
        })
        .catch((err) => {
            NProgress.done();
            return { message: "Error", hasError: true, data: err?.response?.data };
        });
};

export const UpdateCustomComponentHelper = async (params) => {
    toast.info("Saving...");
    return await axiosInstance(`/finance/updateCustomComponent`, {
        method: "PUT",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            custom_component_json: params?.custom_component_json,
            component_type: params?.component_type,
        },
    })
        .then((res) => {
            toast.dismiss();
            toast.success("Changes Applied Successfully");
            return { message: "Successfully Updated", hasError: false, data: res?.data };
        })
        .catch((err) => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message);
            return { message: "Error Updating", hasError: true, data: err?.response?.data };
        });
};

export const GetSalaryComponentSectionHelper = async (params) => {
    const endpoint = params?.component_type === "Deduction"
        ? "/finance/getSalaryDeductionComponentSection"
        : "/finance/getSalaryEarningComponentSection";
    return await axiosInstance(endpoint, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: getDomain(),
            component_type: params?.component_type,
        },
    })
        .then((res) => {
            return { message: "Successfully", hasError: false, data: res?.data };
        })
        .catch((err) => {
            return { message: "Error", hasError: true, data: err?.response?.data };
        });
};

export const UpsertSalaryComponentSectionHelper = async (params) => {
    return await axiosInstance(`/finance/upsertSalaryComponentSection`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: getDomain(),
            section_name: params?.section_name,
            component_type: params?.component_type,
            is_default: params?.is_default,
            user_id: getUserId(),
        },
    })
        .then((res) => {
            toast.dismiss();
            toast.success("Section Saved Successfully");
            return { message: "Successfully Saved", hasError: false, data: res?.data };
        })
        .catch((err) => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message);
            return { message: "Error", hasError: true, data: err?.response?.data };
        });
};

export const DeleteSalaryComponentSectionHelper = async (params) => {
    return await axiosInstance(`/finance/deleteSalaryComponentSection`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: getDomain(),
            section_pk: params?.section_pk,
        },
    })
        .then((res) => {
            toast.dismiss();
            toast.success("Section Deleted Successfully");
            return { message: "Successfully Deleted", hasError: false, data: res?.data };
        })
        .catch((err) => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message);
            return { message: "Error", hasError: true, data: err?.response?.data };
        });
};

export const GetSalaryComponentConfigHelper = async (params) => {
    const endpoint = params?.component_type === "Deduction"
        ? "/finance/getSalaryDeductionComponentConfig"
        : "/finance/getSalaryEarningComponentConfig";
    return await axiosInstance(endpoint, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: getDomain(),
            component_type: params?.component_type,
        },
    })
        .then((res) => {
            return { message: "Successfully", hasError: false, data: res?.data };
        })
        .catch((err) => {
            return { message: "Error", hasError: true, data: err?.response?.data };
        });
};

export const UpsertSalaryComponentConfigHelper = async (params) => {
    return await axiosInstance(`/finance/upsertSalaryComponentConfig`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: getDomain(),
            component_name: params?.component_name,
            component_type: params?.component_type,
            label: params?.label,
            salary_component_section_fk: params?.salary_component_section_fk,
            is_active: params?.is_active,
            user_id: getUserId(),
        },
    })
        .then((res) => {
            return { message: "Successfully Saved", hasError: false, data: res?.data };
        })
        .catch((err) => {
            return { message: "Error", hasError: true, data: err?.response?.data };
        });
};

export const DeleteSalaryComponentConfigHelper = async (params) => {
    return await axiosInstance(`/finance/deleteSalaryComponentConfig`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: getDomain(),
            config_pk: params?.config_pk,
        },
    })
        .then((res) => {
            return { message: "Successfully Deleted", hasError: false, data: res?.data };
        })
        .catch((err) => {
            return { message: "Error", hasError: true, data: err?.response?.data };
        });
};